<script setup lang="ts">
import BaseLayout from '@/components/base/BaseLayout.vue'
import type { FilterOption } from '@/types/filter.types'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import OnlineClassFilterSection from '../components/OnlineClassFilterSection.vue'
import OnlineClassListSection from '../components/OnlineClassListSection.vue'

const router = useRouter()
const route = useRoute()

// 선택된 필터 상태 관리
const selectedCategory = ref<FilterOption>({
  idx: 0,
  name: '라이브 스트리밍',
  data: 'live-streaming',
})

// URL에서 카테고리 가져오기
onMounted(() => {
  const categoryFromQuery = route.query.category as string
  if (categoryFromQuery === 'online-class') {
    selectedCategory.value = {
      idx: 1,
      name: '온라인 수업',
      data: 'online-class',
    }
  }
})

// 카테고리 변경 핸들러
const handleCategoryChange = (category: FilterOption) => {
  selectedCategory.value = category

  // URL 쿼리 파라미터 업데이트
  router.replace({
    query: {
      ...route.query,
      category: category.data,
    },
  })
}
</script>

<template>
  <BaseLayout>
    <div class="online-class-view">
      <OnlineClassFilterSection
        @change="handleCategoryChange"
        :initialCategory="selectedCategory"
      />
      <OnlineClassListSection :selectedCategory="selectedCategory" />
    </div>
  </BaseLayout>
</template>

<style scoped>
.online-class-view {
  padding: 0px;
}

@media (max-width: 1365px) {
  .online-class-view {
    padding: 0px;
  }
}
</style>
